export default "__VITE_ASSET__C_mHg9Ds__"